export default __webpack_public_path__ + "static/media/logo-jokianku.3fb57a44.png";